export * from './SportPersonFootballIcon';
export * from './SportPersonFootballIcon16Light';
export * from './SportPersonFootballIcon16Regular';
export * from './SportPersonFootballIcon16Solid';
export * from './SportPersonFootballIcon20Light';
export * from './SportPersonFootballIcon20Regular';
export * from './SportPersonFootballIcon20Solid';
export * from './SportPersonFootballIcon24Regular';
export * from './SportPersonFootballIcon24Solid';
export * from './SportPersonFootballIcon32Regular';
export * from './SportPersonFootballIcon64Regular';
